import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/userStore'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'landing',
      component: () => import('../views/LandingPage.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('../views/ProfilePage.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('../views/AdminDashboard.vue')
    }
  ]
})

// Restore session before navigating to protected pages
router.beforeEach(async (to) => {
  const userStore = useUserStore()

  // If we have saved auth but no currentUser, restore session from API
  if (userStore.walletAddress && userStore.isAuthenticated && !userStore.currentUser) {
    await userStore.restoreSession()
  }

})

export default router
